// Client-Service für Alerts-CRUD und Push-Registrierung.
import { apiPost, ApiError } from './apiClient';

export { ApiError };

export async function listAlerts() {
  const data = await apiPost('/api/alerts', { action: 'list' });
  return data.alerts || [];
}

export function createAlert(input) {
  return apiPost('/api/alerts', { action: 'create', ...input });
}

export function updateAlert(alertId, patch) {
  return apiPost('/api/alerts', { action: 'update', alertId, patch });
}

export function deleteAlert(alertId) {
  return apiPost('/api/alerts', { action: 'delete', alertId });
}
